'use strict';

const callPlanHatPageActions = (pmtPlanHatService, $location, actionName) => {
	const actions = {
		'site.DashboardV2': () =>
			pmtPlanHatService.trackNavigation('navigateDashboard', $location.absUrl()),
		'site.Locations.Location.Insights.Keywords': () =>
			pmtPlanHatService.trackNavigation('navigateLDPInsightKeywords', $location.absUrl()),
		'site.Insights.Keywords': () =>
			pmtPlanHatService.trackNavigation('navigateInsightKeywords', $location.absUrl()),
		'site.Locations.List': () =>
			pmtPlanHatService.trackNavigation('navigateLocations', $location.absUrl()),
		'site.Insights.Overview': () =>
			pmtPlanHatService.trackNavigation('navigateInsightOverview', $location.absUrl()),
		'site.Insights.Rating': () =>
			pmtPlanHatService.trackNavigation('navigateInsightRating', $location.absUrl()),
		'site.Insights.Google': () =>
			pmtPlanHatService.trackNavigation('navigateInsightGoogle', $location.absUrl()),
		'site.Insights.GoogleOld': () =>
			pmtPlanHatService.trackNavigation('navigateOldInsightGoogle', $location.absUrl()),
		'site.Locations.Location.Insights.GoogleOld': () =>
			pmtPlanHatService.trackNavigation('navigateOldLDPInsightGoogle', $location.absUrl()),
		'site.Locations.Location.Insights.Google': () =>
			pmtPlanHatService.trackNavigation('navigateLDPInsightGoogle', $location.absUrl()),
		'site.Insights.Facebook': () =>
			pmtPlanHatService.trackNavigation('navigateInsightFacebook', $location.absUrl()),
		'site.Locations.Location.Insights.Facebook': () =>
			pmtPlanHatService.trackNavigation('navigateLDPInsightFacebook', $location.absUrl()),
		'site.Insights.FacebookOld': () =>
			pmtPlanHatService.trackNavigation('navigateOldInsightFacebook', $location.absUrl()),
		'site.Locations.Location.Insights.FacebookOld': () =>
			pmtPlanHatService.trackNavigation('navigateOldLDPInsightFacebook', $location.absUrl()),
		'site.Insights.Bing': () =>
			pmtPlanHatService.trackNavigation('navigateInsightBing', $location.absUrl()),
		'site.Insights.System': () =>
			pmtPlanHatService.trackNavigation('navigateInsightSystem', $location.absUrl()),
		'site.MediaReview': () =>
			pmtPlanHatService.trackNavigation('navigateMediaReview', $location.absUrl()),
		'site.AssetsList': () =>
			pmtPlanHatService.trackNavigation('navigateMediaLibrary', $location.absUrl()),
		'site.Locations.AddLocation': () =>
			pmtPlanHatService.trackNavigation('navigateAddLocations', $location.absUrl()),
		'site.NetworksListView': () =>
			pmtPlanHatService.trackNavigation('navigateDirectories', $location.absUrl()),
		'site.Networks.BrandPages': () =>
			pmtPlanHatService.trackNavigation('navigateBrandPage', $location.absUrl()),
		'site.Locations.SpecialHours': () =>
			pmtPlanHatService.trackNavigation('navigateSpecialOpenHours', $location.absUrl()),
		'site.Locations.Location.Details': () =>
			pmtPlanHatService.trackNavigation('navigateLocationDetails', $location.absUrl()),
		'site.Locations.Location.MediaReview': () =>
			pmtPlanHatService.trackNavigation('navigateLocationMediaReview', $location.absUrl()),
		'site.ConflictsResolver': () =>
			pmtPlanHatService.trackNavigation('navigateConflictsResolver', $location.absUrl()),
		'site.Locations.Location.Insights.Overview': () =>
			pmtPlanHatService.trackNavigation('navigateLocationInsightsOverview', $location.absUrl()),
		'site.Locations.Location.NetworkStatus': () =>
			pmtPlanHatService.trackNavigation('navigateLocationNetworkStatus', $location.absUrl()),
		'site.Locations.Import': () =>
			pmtPlanHatService.trackNavigation('navigateLocationsImport', $location.absUrl()),
		'site.Networks.FacebookBrandPages': () =>
			pmtPlanHatService.trackNavigation('navigateNetworksFacebookBrandPages', $location.absUrl()),
		'site.Networks.GoogleBrandPages': () =>
			pmtPlanHatService.trackNavigation('navigateNetworksGoogleBrandPages', $location.absUrl()),
		'site.WorkerLog.Work': () =>
			pmtPlanHatService.trackNavigation('navigateWorkerLogWork', $location.absUrl()),
		'site.Insights.Apple': () =>
			pmtPlanHatService.trackNavigation('navigateInsightApple', $location.absUrl()),
		'site.Locations.Location.Insights.Apple': () =>
			pmtPlanHatService.trackNavigation('navigateLocationInsightsApple', $location.absUrl()),

		default: () => {}
	};
	(actions[actionName] || actions['default'])();
};

module.exports = {
	callPlanHatPageActions
};
